import utils from '@/mixins/utils.js'

export const dataFieldsPorIndicador = {
  mes_ano: 'mes_ano',
  ds_indicador: 'ds_indicador',
  ine: {
    field: 'ine',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  nm_efb: 'nm_efb',
  dn_efb: 'dn_efb',
  peso: 'peso',
  nota: 'nota',
  efb_resultado: 'efb_resultado',
  efb_classificacao: 'efb_classificacao',
}

export const dataFieldsPercentual = {
  'N°': 'colocacao',
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: 'no_equipe',

  'Nota realizada': {
    field: 'nota_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Nota verificada': {
    field: 'nota_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Diferença: {
    field: 'confianca_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },

  'Pontuação realizada': {
    field: 'resultado_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Pontuação verificada': {
    field: 'resultado_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },

  'Classificação realizada': {
    field: 'classificacao_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Classificação verificada': {
    field: 'classificacao_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
}

export const infoHtml = `
`
